import { json } from "@sveltejs/kit";
import { exec } from "child_process";
import { promisify } from "util";
import { W as WORKSPACE_DIR } from "../../../../../chunks/workspace.js";
const execAsync = promisify(exec);
const POST = async ({ request }) => {
  try {
    const { path } = await request.json();
    if (!path) {
      return json({ error: "Path is required" }, { status: 400 });
    }
    await execAsync(`git reset HEAD "${path}"`, { cwd: WORKSPACE_DIR });
    return json({ success: true });
  } catch (error) {
    console.error("Git unstage error:", error);
    return json({ error: "Failed to unstage file" }, { status: 500 });
  }
};
export {
  POST
};
